import { format } from 'date-fns'
import { GetWorkerEvaluationsParams } from 'api/review/getWorkReview'

type WorkReviewKeyFilters = Omit<GetWorkerEvaluationsParams, 'cursor'>

export const reviewRootKey = ['review']
export const reviewOvertimeApprovalKey = [
  ...reviewRootKey,
  'reviewOvertimeApproval',
]
export const reviewTryoutsKey = [...reviewRootKey, 'reviewTryouts']
export const reviewEvaluateKey = [...reviewRootKey, 'reviewEvaluate']
export const workReviewRootKey = [...reviewRootKey, 'workReview']
export const workReviewKey = (filters: WorkReviewKeyFilters) => [
  ...workReviewRootKey,
  {
    reviewStatus: filters.reviewStatus,
    startDate: filters.startDate
      ? format(filters.startDate, 'yyyy-MM-dd')
      : undefined,
    endDate: filters.endDate
      ? format(filters.endDate, 'yyyy-MM-dd')
      : undefined,
    locationId: filters.locationId,
    positionId: filters.positionId,
    workerId: filters.workerId,
  },
]
export const reviewAssignmentsWithRequestedCalloutsKey = [
  ...reviewRootKey,
  'reviewAssignmentsWithRequestedCallouts',
]
